import axios from 'axios'
import { REACT_APP_AUTH_API_DEV } from '../../utils/config'
import axiosInstance from '../../axios/axiosInstance'

export const registerUser = async (data: any) => {
  try {
    const res = await axios.post(`${REACT_APP_AUTH_API_DEV}register/db`, data)
    return res?.data
  } catch (err: any) {
    return err?.response?.data
  }
}

export const loginUser = async (data: any) => {
  try {
    const res = await axios.post(`${REACT_APP_AUTH_API_DEV}loginDB`, data)
    return res?.data
  } catch (err: any) {
    return err?.response?.data
  }
}

export const verifyOtp = async (data: any) => {
  try {
    const res = await axios.post(`${REACT_APP_AUTH_API_DEV}verifyOTP`, data)

    return res?.data
  } catch (err: any) {
    return err?.response?.data
  }
}

/**
 * Redeem an auto-login token from one of our emails. Returns the same payload shape as
 * verifyOtp, so the caller logs the reader in through the existing path.
 */
export const loginWithEmailLink = async (token: string) => {
  try {
    const res = await axios.post(`${REACT_APP_AUTH_API_DEV}auth/email-link`, { token })
    return res?.data
  } catch (err: any) {
    return err?.response?.data
  }
}

export const logoutUser = async () => {
  try {
    const res = await axiosInstance.get(`${REACT_APP_AUTH_API_DEV}logout`)
    return res?.data
  } catch (err: any) {
    return err?.response?.data
  }
}
